import { get, patch, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchLanguageInterface = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("interfacelanguage/list?searchFilter=" + data.searchFilter);
    }, options);
};

export const useAddLanguageInterface = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (newInterfaceLanguage: any) => {
        return await post("interfacelanguage", newInterfaceLanguage);
    }, options);
};

export const useUpdateLanguageInterface = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (updateInterfaceLanguage: any) => {
        return await post("interfacelanguage/update", updateInterfaceLanguage);
    }, options);
};


export const useDeleteLanguageInterface = (options: any) => {
    return useMutation(async (languageInterfaceId) => {
        return await patch(`interfacelanguage/${languageInterfaceId}/delete`, {});
    }, options);
};